module.exports = __webpack_public_path__ + "static/img/devlopment.13883bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/walkInto/devlopment.png
// module id = apQJ
// module chunks = 1